export default __webpack_public_path__ + "static/media/level.e22ef926.svg";